// Publikus szervezői SEO landing route-ok (hub + almodulok) - middleware.js, szervezom/layout.js és a login flow is ezt használja
export const ORGANIZER_PUBLIC_LANDING_SLUGS = ['programok', 'teendoim', 'szolgaltatok', 'vendeglista', 'koltsegvetes', 'ultetesi-rend', 'uzenetek', 'weboldal'];

// A landing oldalak tartalmának utolsó módosítása - sitemap lastModified, tartalomváltozáskor frissíteni kell
export const ORGANIZER_PUBLIC_LANDING_LAST_MODIFIED = "2026-10-07";

export const ORGANIZER_PUBLIC_LANDING_PATHS = ['/szervezom', ...ORGANIZER_PUBLIC_LANDING_SLUGS.map((slug) => `/szervezom/${slug}`)];

export function isOrganizerPublicLandingPath(pathname) {
    if (pathname === '/szervezom') return true;
    return ORGANIZER_PUBLIC_LANDING_SLUGS.some((slug) => pathname === `/szervezom/${slug}`);
}

// null: nem szervezői landing route | "": hub (/szervezom) | egyébként a modul slug-ja
export function getOrganizerPublicLandingSlug(pathname) {
    if (pathname === '/szervezom') return "";
    const match = ORGANIZER_PUBLIC_LANDING_SLUGS.find((slug) => pathname === `/szervezom/${slug}`);
    return match !== undefined ? match : null;
}
